import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { CheckboxFieldWUT } from '../../../ui/checkbox-field';
export const DextCheckboxWUT = (props)=>{
    const fieldType = FIELD_TYPES.DEXT_CHECKBOX;
    return /*#__PURE__*/ React.createElement(CheckboxFieldWUT, {
        ...props,
        fieldType: fieldType
    });
};

//# sourceMappingURL=dext-checkbox-wut.js.map